import React from 'react';
import { Link } from 'react-router-dom';

const SecretLinks = () => {
  const projectLinks = [
    { name: 'XR Thesis', path: '/xr-thesis', color: 'from-purple-500 to-blue-500' },
    { name: 'Connect 2', path: '/connect2', color: 'from-indigo-500 to-purple-500' },
    { name: 'Everything Science', path: '/everything-science', color: 'from-emerald-500 to-teal-500' },
    { name: 'SoleMate', path: '/solemate', color: 'from-cyan-500 to-blue-500' },
    { name: 'Dungeon of the Wild', path: '/dungeon', color: 'from-red-500 to-orange-500' },
    { name: 'Kessler Syndrome', path: '/kessler', color: 'from-blue-500 to-cyan-500' },
    { name: 'Pokémon GO Badges', path: '/pokemon-badges', color: 'from-yellow-500 to-red-500' },
  ];

  const documentLinks = [
    { name: 'Resume (PDF Viewer)', path: '/resume', color: 'from-blue-500 to-blue-600' },
    { name: 'Thesis (PDF Viewer)', path: '/thesis', color: 'from-purple-500 to-purple-600' },
  ];

  const copyToClipboard = (path) => {
    navigator.clipboard.writeText(`arunav.dev${path}`);
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">🔗 Project Links</h1>
          <p className="text-gray-400">Quick access to all project showcase pages</p>
        </div>

        <div className="space-y-4">
          {projectLinks.map((project) => (
            <div 
              key={project.path}
              className="bg-gray-800 border border-gray-700 rounded-xl p-4 hover:border-gray-600 transition-all"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className={`w-3 h-3 rounded-full bg-gradient-to-r ${project.color}`}></div>
                  <div>
                    <h3 className="font-semibold text-white">{project.name}</h3>
                    <p className="text-gray-400 text-sm font-mono">arunav.dev{project.path}</p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => copyToClipboard(project.path)}
                    className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
                    title="Copy URL"
                  >
                    <svg className="w-5 h-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                  </button>
                  <Link
                    to={project.path}
                    className="p-2 bg-blue-600 hover:bg-blue-500 rounded-lg transition-colors"
                    title="Open page"
                  >
                    <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Documents Section */}
        <div className="mt-12">
          <h2 className="text-xl font-bold mb-4 text-gray-300">📄 Documents</h2>
          <div className="space-y-4">
            {documentLinks.map((doc) => (
              <div 
                key={doc.path}
                className="bg-gray-800 border border-gray-700 rounded-xl p-4 hover:border-gray-600 transition-all"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className={`w-3 h-3 rounded-full bg-gradient-to-r ${doc.color}`}></div>
                    <div>
                      <h3 className="font-semibold text-white">{doc.name}</h3>
                      <p className="text-gray-400 text-sm font-mono">arunav.dev{doc.path}</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => copyToClipboard(doc.path)}
                      className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
                      title="Copy URL"
                    >
                      <svg className="w-5 h-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                    <Link
                      to={doc.path}
                      className="p-2 bg-blue-600 hover:bg-blue-500 rounded-lg transition-colors"
                      title="Open page"
                    >
                      <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/"
            className="text-gray-400 hover:text-white transition-colors"
          >
            ← Back to Portfolio
          </Link>
        </div>

        <div className="mt-8 p-4 bg-gray-800/50 border border-gray-700 rounded-xl">
          <p className="text-gray-500 text-sm text-center">
            🤫 This page is unlisted and won't appear in navigation
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecretLinks;